import type { KidsPolicyItemInput } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { FormErrorMessage, FormItem } from "@/components/ui/form/_base/form";

import { QuestionKidsPolicyItem } from "./item";
import { QuestionCardItemsWrapper } from "../../../system/question/card/card-items-wrapper";

import type { StatusesGenerator } from "../../../../../types/edit-statuses";
import type { ComponentProps } from "react";

type Props = {
	kidsPolicy: StatusesGenerator<KidsPolicyItemInput, "">[] | undefined;

	appendKidsPolicyItem: () => void;

	label?: string;
	guide?: string;
	errorMessage?: string;
	priceTypeLabel?: string;

	isEdited: boolean | undefined;
	hasError: boolean | undefined;

	questionKidsPolicyItemProps: Omit<ComponentProps<typeof QuestionKidsPolicyItem>, "kidsPolicyItem" | "index" | "priceTypeLabel">;
};

export const QuestionKidsPolicy = ({
	kidsPolicy,
	appendKidsPolicyItem,
	questionKidsPolicyItemProps,
	errorMessage,
	label,
	guide,
	priceTypeLabel,
	isEdited,
	hasError,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label || "キッズポリシー"}
			guide={guide}
			isEdited={isEdited ?? false}
			hasError={hasError ?? false}
			inputChildren={
				<QuestionCardItemsWrapper appendItem={appendKidsPolicyItem}>
					<FormItem>
						<FormErrorMessage>{errorMessage}</FormErrorMessage>
						{kidsPolicy?.map((item, index) => {
							return (
								<QuestionKidsPolicyItem
									key={`question-room-kids-policy-${index}`}
									index={index}
									kidsPolicyItem={item}
									priceTypeLabel={priceTypeLabel}
									{...questionKidsPolicyItemProps}
								/>
							);
						})}
					</FormItem>
				</QuestionCardItemsWrapper>
			}
		/>
	);
};

QuestionKidsPolicy.displayName = "QuestionKidsPolicy";
